import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Also attach Authorization header if token in localStorage (belt & braces).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vt_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  // Cloudflare / proxy HTML error pages (413, 520, 522, 524 …)
  const status = err?.response?.status;
  if (status === 413) return "The video is too large for a direct upload. Please retry — chunked upload will kick in automatically for files over 20 MB.";
  if (status === 502 || status === 503 || status === 504) return "The server is temporarily unreachable. Please try again in a moment.";
  if (status === 520 || status === 521 || status === 522 || status === 523 || status === 524 || status === 525 || status === 526) {
    return "Network hiccup between your browser and the server (Cloudflare). Please retry — the upload will resume in chunks.";
  }

  const raw = err?.response?.data;
  if (raw && typeof raw === "string" && /<html|<!doctype/i.test(raw)) {
    return "Unexpected non-JSON response from the server. Please retry.";
  }

  const detail = raw?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  return String(detail);
}

export default api;
